const EN_LEVEL = 'Beginner to advanced';
const RU_LEVEL = 'От начального до продвинутого уровня';
const AZ_LEVEL = 'Başlanğıcdan irəli səviyyəyədək';
const SUBJECTS = {
    en: {
        piano: {
            name: 'Piano',
            level: EN_LEVEL,
            tagline: 'Where most people start, and plenty never leave.',
            description: 'Classical grounding or straight into the songs you actually want to play — the two are not opposites, and a good teacher moves between them. Weekly one-to-one lessons on a real acoustic instrument.',
        },
        vocal: {
            name: 'Vocal',
            level: EN_LEVEL,
            tagline: 'Your instrument is already there. This is learning to use it.',
            description: 'Breath, support, range and the confidence to use all three. Lessons cover technique and repertoire together, because one without the other does not hold up on stage.',
        },
        guitar: {
            name: 'Guitar',
            level: EN_LEVEL,
            tagline: 'Six strings, and a shorter road to your first song than you think.',
            description: 'Acoustic and classical guitar from the first chord shape to fingerstyle arrangements. We start with something you can play by the end of the lesson.',
        },
        'electric-guitar': {
            name: 'Electric Guitar',
            level: EN_LEVEL,
            tagline: 'Tone, timing, and the parts that actually make a track work.',
            description: 'Rhythm and lead, amps and effects, and the ensemble skills that separate a bedroom player from someone a band wants. Runs alongside the band rehearsal room.',
        },
        drums: {
            name: 'Drums',
            level: EN_LEVEL,
            tagline: 'The loudest way to learn to count.',
            description: 'Groove, independence and reading, on a full acoustic kit in a properly treated room. Beginners get a usable beat in the first lesson.',
        },
        handpan: {
            name: 'Handpan',
            level: EN_LEVEL,
            tagline: 'No wrong notes. That is the point, and also the challenge.',
            description: 'The instrument is tuned so everything sounds good; the work is in rhythm, dynamics and building something that goes somewhere. Popular as a second instrument.',
        },
        violin: {
            name: 'Violin',
            level: EN_LEVEL,
            tagline: 'Patient, precise, and worth every hour.',
            description: 'Posture, bow control and intonation taught properly from the start, because the habits formed in the first year are the ones that last. Classical and folk repertoire.',
        },
        fingerstyle: {
            name: 'Fingerstyle',
            level: EN_LEVEL,
            tagline: 'Melody, bass and rhythm from one guitar. The only fingerstyle course in Baku.',
            description: 'A whole song on one acoustic guitar: the thumb keeps the bass line, the fingers carry the melody, and the body of the guitar becomes the drum. For anyone who wants the guitar to sound like a band.',
        },
    },
    ru: {
        piano: {
            name: 'Фортепиано',
            level: RU_LEVEL,
            tagline: 'С него начинает большинство, и многие так и остаются.',
            description: 'Классическая база или сразу песни, которые вам действительно хочется играть, — одно другому не мешает, и хороший преподаватель свободно переходит от одного к другому. Еженедельные индивидуальные занятия на настоящем акустическом инструменте.',
        },
        vocal: {
            name: 'Вокал',
            level: RU_LEVEL,
            tagline: 'Инструмент у вас уже есть. Осталось научиться им пользоваться.',
            description: 'Дыхание, опора, диапазон и уверенность, чтобы пользоваться всем этим. На занятиях техника и репертуар идут вместе: одно без другого на сцене не работает.',
        },
        guitar: {
            name: 'Гитара',
            level: RU_LEVEL,
            tagline: 'Шесть струн — и до первой песни ближе, чем кажется.',
            description: 'Акустическая и классическая гитара — от первого аккорда до аранжировок пальцевым стилем. Начинаем с того, что вы сможете сыграть уже к концу урока.',
        },
        'electric-guitar': {
            name: 'Электрогитара',
            level: RU_LEVEL,
            tagline: 'Звук, чувство ритма и партии, на которых держится трек.',
            description: 'Ритм и соло, усилители и эффекты, а ещё навыки игры в ансамбле, которые отличают домашнего гитариста от того, кого хочет взять группа. Занятия идут рядом с репетиционной комнатой для групп.',
        },
        drums: {
            name: 'Барабаны',
            level: RU_LEVEL,
            tagline: 'Самый громкий способ научиться считать.',
            description: 'Грув, независимость рук и ног и чтение нот — на полной акустической установке в комнате с настоящей акустической отделкой. Новичок уже на первом уроке играет рабочий ритм.',
        },
        handpan: {
            name: 'Ханг',
            level: RU_LEVEL,
            tagline: 'Здесь нет неправильных нот. В этом и смысл, и сложность.',
            description: 'Инструмент настроен так, что всё звучит красиво; работа — в ритме, динамике и в том, чтобы сыгранное куда-то вело. Его часто выбирают вторым инструментом.',
        },
        violin: {
            name: 'Скрипка',
            level: RU_LEVEL,
            tagline: 'Требует терпения и точности — и стоит каждого часа.',
            description: 'Постановка, владение смычком и интонация — правильно с самого начала, потому что привычки первого года остаются надолго. Классический и народный репертуар.',
        },
        fingerstyle: {
            name: 'Фингерстайл',
            level: RU_LEVEL,
            tagline: 'Мелодия, бас и ритм на одной гитаре. Единственный курс фингерстайла в Баку.',
            description: 'Целая песня на одной акустической гитаре: большой палец ведёт бас, остальные — мелодию, а корпус гитары становится барабаном. Для тех, кто хочет, чтобы гитара звучала как целая группа.',
        },
    },
    az: {
        piano: {
            name: 'Fortepiano',
            level: AZ_LEVEL,
            tagline: 'Çoxları buradan başlayır, bir çoxu da burada qalır.',
            description: 'Klassik əsaslar və ya birbaşa həqiqətən çalmaq istədiyiniz mahnılar — bunlar bir-birinə zidd deyil və yaxşı müəllim ikisi arasında rahat keçid edir. Əsl akustik alətdə həftəlik fərdi dərslər.',
        },
        vocal: {
            name: 'Vokal',
            level: AZ_LEVEL,
            tagline: 'Alətiniz artıq sizdədir. İndi ondan istifadə etməyi öyrənirsiniz.',
            description: 'Nəfəs, dayaq, diapazon və bunların hamısından istifadə etmək üçün özünəinam. Dərslərdə texnika və repertuar birlikdə gedir, çünki biri digəri olmadan səhnədə alınmır.',
        },
        guitar: {
            name: 'Gitara',
            level: AZ_LEVEL,
            tagline: 'Altı sim və ilk mahnınıza düşündüyünüzdən daha qısa yol.',
            description: 'Akustik və klassik gitara — ilk akkorddan barmaq texnikası ilə aranjimanlara qədər. Dərsin sonunda çala biləcəyiniz bir şeylə başlayırıq.',
        },
        'electric-guitar': {
            name: 'Elektrogitara',
            level: AZ_LEVEL,
            tagline: 'Səs tembri, ritm hissi və trekin əsasını təşkil edən partiyalar.',
            description: 'Ritm və solo, gücləndiricilər və effektlər, həmçinin evdə çalan gitaraçını qrupun istədiyi musiqiçidən fərqləndirən ansambl bacarıqları. Qrup məşq otağı ilə yanaşı keçirilir.',
        },
        drums: {
            name: 'Zərb alətləri',
            level: AZ_LEVEL,
            tagline: 'Saymağı öyrənməyin ən səs-küylü yolu.',
            description: 'Qruv, əl və ayaqların müstəqilliyi və not oxuma — akustik cəhətdən düzgün işlənmiş otaqda tam akustik dəstdə. Yeni başlayanlar ilk dərsdə işlək bir ritm çalır.',
        },
        handpan: {
            name: 'Handpan',
            level: AZ_LEVEL,
            tagline: 'Səhv not yoxdur. Məqsəd də, çətinlik də elə budur.',
            description: 'Alət elə köklənib ki, hər şey gözəl səslənir; iş ritmdə, dinamikada və bir yerə aparan nəsə qurmaqdadır. Çox vaxt ikinci alət kimi seçilir.',
        },
        violin: {
            name: 'Skripka',
            level: AZ_LEVEL,
            tagline: 'Səbir və dəqiqlik tələb edir — və hər saata dəyər.',
            description: 'Duruş, kamana nəzarət və intonasiya — ilk gündən düzgün öyrədilir, çünki ilk ildə yaranan vərdişlər uzun müddət qalır. Klassik və xalq repertuarı.',
        },
        fingerstyle: {
            name: 'Fingerstyle',
            level: AZ_LEVEL,
            tagline: 'Bir gitarada melodiya, bas və ritm. Bakıda yeganə fingerstyle kursu.',
            description: 'Bütöv mahnı bir akustik gitarada: baş barmaq bas xəttini aparır, digər barmaqlar melodiyanı, gitaranın gövdəsi isə nağaraya çevrilir. Gitaranın bütöv qrup kimi səslənməsini istəyənlər üçün.',
        },
    },
};
export function catalogueDictionary(locale) {
    const entries = {};
    for (const [slug, copy] of Object.entries(SUBJECTS[locale])) {
        entries[`subject.${slug}.name`] = copy.name;
        entries[`subject.${slug}.level`] = copy.level;
        entries[`subject.${slug}.tagline`] = copy.tagline;
        entries[`subject.${slug}.description`] = copy.description;
    }
    return entries;
}
export function subjectName(slug, locale, fallback) {
    return SUBJECTS[locale][slug]?.name ?? fallback;
}
//# sourceMappingURL=catalogue.js.map